import injectScript from './inject-script'

const src = 'https://www.google.com/recaptcha/api.js?render=explicit'


export const captchaKey= "6LfpLXAUAAAAAMa5KSp5h6JU-vfoWWG0wFiulfTD"

export function initializeCaptcha () {
  return injectScript(src).then(onRecaptchaLoadCallback)
}

// NOTE - this may not be comprehensive.
export function removeCaptcha () {
  const script = document.querySelector(`script[src="${src}"]`)
  const captcha = document.querySelector('.grecaptcha-badge')

  if (script) script.remove()
  if (captcha) captcha.remove()
  if (window.grecaptcha) {
    delete window.grecaptcha
  }
}

export function onRecaptchaLoadCallback () {
    const { grecaptcha } = window
    grecaptcha.ready(() => {
      grecaptcha.render(
        'inline-badge',
        {
          'sitekey': captchaKey,
          'badge': 'bottomleft',
          'size': 'invisible',
        }
      )
     })
}
